module.exports = __webpack_public_path__ + "8177f51fa3bd51ee6aebfb0ab12fdf31.svg";